// extracted by mini-css-extract-plugin
export default {"video_poster":"BaseVideoPoster_video_poster_GWw9q","play_icon":"BaseVideoPoster_play_icon_z1P_3","poster":"BaseVideoPoster_poster_N56mM"};